export const createOrderNumber = () => {
  const timestamp = Date.now().toString();
  const random = Array.from({ length: 10 }, () => Math.floor(Math.random() * 10)).join("");
  return `${timestamp}${random}`;
};

export const buildPaymentUrl = ({ orderNo, amount, currency, email, title }) => {
  const origin = window.location.origin;
  const params = new URLSearchParams({
    orderNo,
    amount: Number(amount).toFixed(2),
    currency,
    email,
    success_url: `${origin}/payment?state=success`,
    cancel_url: `${origin}/payment?state=cancel`,
    title,
  });
  return `${origin}/create_payment.php?${params.toString()}`;
};
